import { useQuery } from "@tanstack/react-query"
import { api, type Registry } from "@/api.js"

/**
 * The questions this build answers, as the panel names them.
 *
 * Deferred payment is the first and, today, the only one — but a decision, an
 * override and a rule set each belong to a question, so every screen that
 * shows one needs the Polish title for its id. Read from the registry the
 * installed packages populate, the same place the reason codes come from, so a
 * second question appears here without this file being edited.
 */
export type QuestionSummary = Registry["questions"][number]

export function useQuestions(): {
  readonly questions: readonly QuestionSummary[]
  readonly titleOf: (questionId: string) => string
} {
  const registry = useQuery({ queryKey: ["registry"], queryFn: api.registry })
  const questions = registry.data?.questions ?? []
  return {
    questions,
    // A question a later build removed still has to read as something: the id
    // is honest where a title is not known.
    titleOf: (questionId) =>
      questions.find((question) => question.questionId === questionId)?.title ?? questionId,
  }
}
